import { isEmptyDocument } from '@atlaskit/editor-common/utils/document';
import { Selection, TextSelection } from '@atlaskit/editor-prosemirror/state';

import type {
	AppendNodeCommand,
	StreamingCommandFactory,
} from '../aiStreamingOrchestratorPluginType';

export const createAppendNodeCommand: StreamingCommandFactory<AppendNodeCommand> =
	(api) => (command) => {
		api.core.actions.execute(({ tr }) => {
			let selection: Selection;
			if (isEmptyDocument(tr.doc)) {
				selection = Selection.atEnd(tr.doc);
			} else {
				const $pos = tr.doc.resolve(tr.doc.content.size);
				tr.insert($pos.pos, tr.doc.type.schema.nodes.paragraph.create());
				selection = TextSelection.create(tr.doc, $pos.pos + 1);
			}
			if (!selection) {
				throw new Error('Failed to create selection');
			}
			if (command.value) {
				tr.setSelection(selection).replaceSelectionWith(command.value).scrollIntoView();
			} else {
				tr.setSelection(selection).scrollIntoView();
			}
			return tr;
		});
		return true;
	};
